import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { Spinner } from "../../Common";
import { accountTransactions } from "../../api";
import { format } from "date-fns";
import styles from "./accountTransaction.module.css";
import DataTable from "../../Common/DataTable/DataTable";
import { addDays } from "date-fns";
import Filter from "./TransactionFilter"
import singleRight from "../../public/images/singleRight.png";
import singleLeftSvg from "../../public/images/singleLeft.svg";
import {transactionTypeMap} from "../../utils/utils";

const userColumns = [
 
  {
    Header: "Transaction Date",
    accessor: "tranWhen",
    search: false,
    sort: "ASC",
  },
  {
    Header: "Transaction Type",
    accessor: "finTranTypeID",
    Cell: ({ row }) => {
      return row.original.finTranTypeID
        ? transactionTypeMap[row.original.finTranTypeID] ||
            row.original.finTranTypeID
        : "--";
    },
    search: false,
    formatText: true,
  },
  {
    Header: "Amount",
    accessor: "accountAmount",
    search: false,
  },
  {
    Header: "Balance",
    accessor: "accountBalance",
    search: false,
  },
  {
    Header: "Comment",
    accessor: "comment",
    search: false,
  },
  // {
  //   Header: "User ID",
  //   accessor: "userID",
  //   search: false,
  // },

];

function AccountTransactions({custId}) {
  const [accountNo, setAccountNo] = useState("");
  const date = new Date();
  const [startDate, setStartDate] = useState(addDays(date, -15));
  const [endDate, setEndDate] = useState(date);
  const [transactionList, setTransactionList] = useState([]);
  const [selectedTransactionType, setSelectedTransactionType] = useState({key: "", value: "ALL"});
  const [dataLoading, setDataLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [userId, setUserId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize] = useState(20);

  const getAccountTransactions = async (
    startDate,
    endDate,
    accountNo,
    transactionType,
    newOrder = "ASC",
    pageNumber
  ) => {
    setDataLoading(true);
    try {
      const response = await accountTransactions({
        custId,
        startDate,
        endDate,
        accountNo,
        selectedTransactionType:transactionType?.key,
        newOrder,
        pageNumber,
        pageSize,
      });
      setDataLoading(false);
      if (response?.data?.code === 400) {
        setErrorMessage(response.data.message);
        setTransactionList([]);
        setTotalPages(1);
        return;
      }
      if (response?.data?.data) {
        const transactions = response.data.data.result || [];
        const totalRecords = response.data.data.totalRecords || 0;
        
        setTransactionList(transactions);
        setTotalPages(Math.ceil(totalRecords / pageSize));
      } else {
        setTransactionList([]);
        setTotalPages(1);
      }
    } catch (e) {
      setDataLoading(false);
      setTransactionList([]);
      setTotalPages(1);
    }
  };

  useEffect(() => {
    const dateStart = format(startDate, "yyyy-MM-dd");
    const dateEnd = format(endDate, "yyyy-MM-dd");
    getAccountTransactions(dateStart, 
      dateEnd, 
      accountNo, 
      selectedTransactionType,
      "ASC",
      currentPage
    );
  }, [custId, currentPage]);

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };
  
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const onSubmit = () => {
    if (startDate && endDate) {
      setErrorMessage("");
      setCurrentPage(1);
      const dateStart = format(startDate, "yyyy-MM-dd");
      const dateEnd = format(endDate, "yyyy-MM-dd");
      getAccountTransactions(
        dateStart, 
        dateEnd, 
        accountNo, 
        selectedTransactionType,
        "ASC",
        1
      );
    } else {
      setErrorMessage("Please Select Date");
    }
  };


  return (
    <div className={styles.container}>
      <Card className={styles.customCard}>
        <Card.Body className={styles.customCardBody}>
          <Filter
            accountNo={accountNo}
            setAccountNo={setAccountNo}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            onSearch={onSubmit}
            errorMessage={errorMessage}
            transactionTypeList={["CSR", "CSD", "CSR,CSD"]}
            selectedTransactionType={selectedTransactionType}
            setSelectedTransactionType={setSelectedTransactionType}
            userId={userId}
            setUserId={setUserId}
            filterUserId={false}
          />
        </Card.Body>
      </Card>
      {dataLoading ? (
        <Spinner />
      ) : (
        Array.isArray(transactionList) && transactionList.length > 0 ? (
          <>
          <DataTable 
            columns={userColumns} 
            list={transactionList} 
            rowClick={false} 
          />
          
          <div className={styles.paginationButtons}>
            <div>
              <img
                alt="Previous"
                src={singleLeftSvg}
                onClick={handlePrevious}
                className={styles.arrowButton}
              />
              <span
                style={{
                  fontSize: "13px",
                  marginLeft: "10px",
                  cursor: "pointer",
                }}
                onClick={handlePrevious}
              >
                Previous
              </span>
            </div>
            <span style={{ margin: "0px 20px", fontSize: "13px" }}>
              Page {currentPage} / {totalPages}
            </span>
            <div>
              <span
                style={{
                  fontSize: "13px",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
                onClick={handleNext}
              >
                Next
              </span>
              <img
                alt="Next"
                src={singleRight}
                onClick={handleNext}
                className={styles.arrowButton}
              />
            </div>
          </div>
        </>
        ) : (
          <p style={{ color: "white", marginTop: "20px",textAlign: "center" }}>No Data Found</p>
        )
      )}
    </div>
  );
}

export default AccountTransactions;
